import { Action, TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { drilldownData } from "@utils/drilldownData";
import { message, Pagination, TableColumnsType, Tabs, Typography } from "antd";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, DataTable } from "~/Components";
import { get, put } from "~/Services";
import { getCurrentModule, getModulePath } from "~/Utils/StringConstants";
import { renderActionsColumn, renderDateColumn, renderUpdatedAtColumn } from "~/Utils/TableRenderFunction";
import { drilldownDataCorporate } from "~/Utils/drilldownDataDum";
import ActionDropdown from "../StatusInformation/ActionDropdown";
import { formatSubModule, generateFieldsFromPayload, unformatSubModule } from "../StatusInformation/StatusInformation";

export const CorporateApprovalManagement = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchString, setSearchString] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [orderByName, setOrderByName] = useState<string>("createdAt");
  const [corporateDrilldown, setCorporateDrilldown] = useState<any>();
  const [fetchCorporateDrilldown, setFetchCorporateDrilldown] = useState<any>();
  const [corporateIndex, setCorporateIndex] = useState<number>();
  const [approvalId, setApprovalId] = useState<string | undefined>();

  const fetchDrilldownData = async () => {
    try {
      const drilldownDataForCorporate: any = await drilldownDataCorporate();
      setCorporateDrilldown(drilldownDataForCorporate);
    } catch (error) {
      console.error("Error fetching drilldown data:", error);
    }
  };
  useEffect(() => {
    fetchDrilldownData();
  }, []);

  useEffect(() => {
    if (selectedRowData?.module === "CorporateProfile") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if (module === "ourPolicies" || module === "ourAirports") {
        if (subModule === "ourAirportsPageHeading" || subModule === "ourPoliciesPageHeading") {
          setFetchCorporateDrilldown(subModule);
          return;
        }
        if ([module, subModule, thirdChildSubModule, index].includes("nextPage")) {
          setFetchCorporateDrilldown(`${subModule}OurPolicies`);
          return;
        }
        setCorporateIndex(index);
        setFetchCorporateDrilldown(subModule + module.charAt(0).toUpperCase() + module.slice(1));
      } else if (module === "ourProfile") {
        if (subModule === "ourProfilePageHeading") {
          setFetchCorporateDrilldown(subModule);
          return;
        }
        if ([module, subModule, thirdChildSubModule, index].includes("nextPage")) {
          setFetchCorporateDrilldown(`${subModule}OurPolicies`);
          return;
        }
        setFetchCorporateDrilldown(module);
        setCorporateIndex(thirdChildSubModule);
      } else if (module === "ourBrand") {
        setFetchCorporateDrilldown(subModule);
        return;
      }
    } else if (selectedRowData?.module === "Subsidiaries") {
       const [module, subModule, index] = selectedRowData?.subModule?.split("_") || [];
        if (module === "subsidiariesPageHeading") {
          return;
        } 
        if ([module, subModule, index].includes("nextPage")) {
          setFetchCorporateDrilldown(`nextPageSubsidiaries`);
          return;
        }
        setFetchCorporateDrilldown(module);
        setCorporateIndex(index);
      } else if (selectedRowData?.module === "Sustainability") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if (module === "landing") {
        if (subModule === "landingPageHeading") {
          setFetchCorporateDrilldown(subModule);
          return;
        }
        setFetchCorporateDrilldown(module);
        setCorporateIndex(thirdChildSubModule);
      } else if (module === "ftse4good") {
        setFetchCorporateDrilldown(subModule);
        return;
      } else if (module === "reports") {
        if (subModule === "reportsMainContent") {
          setFetchCorporateDrilldown(subModule);
          return;
        } else {
          setFetchCorporateDrilldown(subModule);
          setCorporateIndex(index);
          return;
        }
      } else {
        if (
          subModule === "practisingSensibleEconomicsPageHeading" ||
          subModule === "environmentalConsciousnessPageHeading" ||
          subModule === "creatingInspiringWorkplacePageHeading" ||
          subModule === "communityFriendlyOrganisationPageHeading" ||
          subModule === "memorableAirportExperiencesPageHeading" ||
          subModule === "ftse4GoodPageHeading" ||
          subModule === "reportsPageHeading"
        ) {
          setFetchCorporateDrilldown(subModule);
          return;
        }
        setFetchCorporateDrilldown(module + subModule);
        setCorporateIndex(index);
      }
    } else if (selectedRowData?.module === "Media Center") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if (module === "news") {
        if (
          subModule === "newsPageHeading" ||
          subModule === "latestNewsPageHeading" ||
          subModule === "archivesNewsPageHeading" || 
          subModule === "latestNewsNextPage" ||
          subModule === "archivesNewsNextPage"
        ) {
          setFetchCorporateDrilldown(subModule);
          return;
        } else {
          setFetchCorporateDrilldown(module);
        }
      }
    } else if (selectedRowData?.module === "Awards") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      setFetchCorporateDrilldown(subModule);
    } else if (selectedRowData?.module === "Organization") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      setFetchCorporateDrilldown(subModule);
    } else if (selectedRowData?.module === "Malaysia Airport Academy") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if (
        subModule === "latestNews" ||
        subModule === "latestNewsList" ||
        subModule === "parentHeader" ||
        subModule === "childHeader" ||
        subModule === "grandChildHeader" ||
        subModule === "milestoneLinks" ||
        subModule === "milestoneOverview"
      ) {
        setFetchCorporateDrilldown(subModule);
        return;
      }
      setFetchCorporateDrilldown(module);
    } else if (selectedRowData?.module === "Stake Holders") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if (
        subModule === "agenciesPageHeading" ||
        subModule === "airlinesPageHeading" ||
        subModule === "cargoPageHeading" ||
        subModule === "groundHandlersPageHeading" || 
        subModule === "agenciesNextPage" ||
        subModule === "airlinesNextPage" ||
        subModule === "cargoNextPage" ||
        subModule === "groundHandlersNextPage" 
      ) {
        setFetchCorporateDrilldown(subModule);
      } else {
        setFetchCorporateDrilldown(module);
      }
    } else if (selectedRowData?.module === "Navigation") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if(thirdChildSubModule) {
        setFetchCorporateDrilldown(thirdChildSubModule);
        return;
      } else if(subModule === "aboutAndLegal") {
        setFetchCorporateDrilldown(subModule);
        return;
      }
      setFetchCorporateDrilldown(module);
    } else if (selectedRowData?.module === "Contact Us") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      setFetchCorporateDrilldown(subModule);
    } else if (selectedRowData?.module === "Business Opportunities") {
      const [module, subModule, thirdChildSubModule, index] = selectedRowData?.subModule?.split("_") || [];
      if(module === "commercialLeasingOpportunitiesList") {
        return;
      }
      if (thirdChildSubModule) {
        setFetchCorporateDrilldown(module);
        setCorporateIndex(thirdChildSubModule);
        return;
      }
      setFetchCorporateDrilldown(subModule);
    }
  }, [selectedRowData]);

  const [actionType, setActionType] = useState<string>();

  useEffect(() => {
    setApprovalId(selectedRowData?.approvalId);
  }, [selectedRowData]);

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/approval-management?activeTab=pending`, {
        replace: true,
      });
    }
  }, [navigate, query]);

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useDocumentDetails(approvalId || "");

  function capitalizeFirstLetter(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  useEffect(() => {
    if (approvalId) {
      refetchDocument();
    }
  }, [approvalId, refetchDocument]);

  const renderSubModule = (text: string) => capitalizeFirstLetter(text);

  const columns: TableColumnsType = [
    {
      title: "Request Type",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "module"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "module"
            ? "descend"
            : undefined,
    },
    {
      title: "Sub Module",
      dataIndex: "subModule",
      key: "subModule",
      render: (text: string) => formatSubModule(text),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subModule"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subModule"
            ? "descend"
            : undefined,
    },
    {
      title: "Requested At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Requested By",
      dataIndex: "createdBy",
      key: "createdBy",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdBy"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdBy"
            ? "descend"
            : undefined,
    },
    {
      title: "Approved At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Rejected At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Approved By",
      dataIndex: "updatedBy",
      key: "updatedBy",
      render: (text: string) => renderUpdatedAtColumn(text),
    },
    {
      title: "Rejected By",
      dataIndex: "updatedBy",
      key: "updatedBy",
      render: (text: string) => renderUpdatedAtColumn(text),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedBy"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedBy"
            ? "descend"
            : undefined,
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectReason",
      key: "rejectReason",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "rejectReason"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "rejectReason"
            ? "descend"
            : undefined,
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: any) => {
        const name = "approvalManagement";
        return query.get("activeTab") === "pending"
          ? renderActionsColumn(record, undefined, undefined, undefined, undefined, undefined, name)
          : renderActionsColumn(record);
      },
    },
  ];

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    setCurrentPage(0);
    getRecords(order, column.dataIndex, searchString, currentPage);
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    const unformattedValue = unformatSubModule(value);
    setSearchString(unformattedValue);
    setIsLoading(isLoading);
  }, 1000);

  useEffect(() => {
    getRecords("desc", "createdAt", searchString, currentPage);
  }, [query?.get("activeTab"), actionType]);

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, 0);
  }, [searchString]);

  const getColumnsByTab = (activeTab: string) => {
    const filteredColumns = columns.filter((column) => {
      if (typeof column.title === "string") {
        switch (activeTab) {
          case "pending":
            return ["Request Type", "Module", "Sub Module", "Requested At", "Requested By", "Actions"].includes(
              column.title
            );
          case "approved":
            return [
              "Request Type",
              "Module",
              "Sub Module",
              "Approved At",
              "Approved By",
              "Requested By",
              "Requested At",
              "Actions",
            ].includes(column.title);
          case "rejected":
            return [
              "Request Type",
              "Module",
              "Sub Module",
              "Rejected At",
              "Rejected By",
              "Requested By",
              "Requested At",
              "Rejected Reason",
              "Actions",
            ].includes(column.title);
          default:
            return true;
        }
      }
      return false;
    });

    return filteredColumns.map((col: any) => ({
      ...col,
      onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
    }));
  };

  const handleApprove = async () => {
    try {
      const formdata = new FormData();
      formdata.append("approvalId", selectedRowData.approvalId);
      formdata.append("status", "APPROVED");
      await put("management/update-status", formdata);
      message.success("Approved successfully!");
      getRecords(sortOrder, orderByName, searchString, currentPage);
      setDrawerVisible(false);
    } catch (error) {
      message.error("Failed to approve!");
    }
  };

  const handleReject = async (reason?: string) => {
    if (!reason) return message.error("Please provide reason for rejection");
    try {
      const formdata = new FormData();
      formdata.append("approvalId", selectedRowData.approvalId);
      formdata.append("status", "REJECTED");
      formdata.append("rejectReason", reason);
      await put("management/update-status", formdata);
      message.success("Rejected successfully!");
      getRecords(sortOrder, orderByName, searchString, currentPage);
      setDrawerVisible(false);
    } catch (error) {
      message.error("Failed to reject!");
    }
  };

  const actions: Action[] = [
    { label: "Approve", onClick: handleApprove, type: "primary" },
    { label: "Reject", onClick: handleReject, type: "ghost" },
  ];

  const items = [
    {
      label: "Pending",
      key: "pending",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={getColumnsByTab("pending")}
            className="table-clickable"
            tableData={data?.map((d: any) => ({ ...d })) || []}
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText="Search Module/ SubModule"
            onSearchChange={handleSearchChange}
            onClick={(record) => {
              setSelectedRowData(record);
              setDrawerVisible(true);
            }}
            additionalCTA={
              <ActionDropdown
                value={actionType}
                onChange={setActionType}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage + 1}
              total={totalRecords}
              onChange={(curPage) => {
                const page = curPage - 1;
                setCurrentPage(page);
                getRecords(sortOrder, orderByName, searchString, page);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Rejected",
      key: "rejected",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={getColumnsByTab("rejected")}
            className="table-clickable"
            tableData={data?.map((d: any) => ({ ...d })) || []}
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            isServerSearchApi={true}
            multiSelect={false}
            hideExport={true}
            searchPlaceholderText="Search Module/ SubModule"
            onSearchChange={handleSearchChange}
            onClick={(record) => {
              setSelectedRowData(record);
              setDrawerVisible(true);
            }}
            additionalCTA={
              <ActionDropdown
                value={actionType}
                onChange={setActionType}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage + 1}
              total={totalRecords}
              onChange={(curPage) => {
                const page = curPage - 1;
                setCurrentPage(page);
                getRecords(sortOrder, orderByName, searchString, page);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Approved",
      key: "approved",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={getColumnsByTab("approved")}
            className="table-clickable"
            tableData={data?.map((d: any) => ({ ...d })) || []}
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText="Search Module/ SubModule"
            onSearchChange={handleSearchChange}
            onClick={(record) => {
              setSelectedRowData(record);
              setDrawerVisible(true);
            }}
            additionalCTA={
              <ActionDropdown
                value={actionType}
                onChange={setActionType}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage + 1}
              total={totalRecords}
              onChange={(curPage) => {
                const page = curPage - 1;
                setCurrentPage(page);
                getRecords(sortOrder, orderByName, searchString, page);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
  ];

  const getRecords = async (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    const activeTab = query?.get("activeTab");
    if (!activeTab) return;
    const currentModule = getCurrentModule();
    setIsLoading(true);
    const url = `management/get-documents?page=${currentPage}&size=10&application=${getModulePath(currentModule)?.charAt(0)?.toUpperCase() + getModulePath(currentModule)?.slice(1)?.toLowerCase()}&status=${activeTab}&order=${sortOrder}&orderBy=${orderByParam}&searchText=${searchString}${actionType ? `&action=${actionType}` : ""}`;
    try {
      const res: any = await get(url);
      if (res && res.response.data) {
        setTotalRecords(res.response.data.total);
        setData(res.response.data.records);
      } else {
        setData([]);
      }
    } catch (err) {
      setData([]);
      console.error("Error fetching records:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDrawer = () => {
    setDrawerVisible(false);
    setSelectedRowData(null);
    setApprovalId(undefined);
    setFetchCorporateDrilldown(undefined);
    setCorporateIndex(undefined);
  };

  const predefinedFields =
    drilldown?.appList?.[0]?.appName === "CORPORATE" || drilldown?.appList?.[0]?.appName === "MAHB_CORPORATE"
      ? corporateIndex !== undefined && corporateDrilldown?.[fetchCorporateDrilldown]?.[corporateIndex]
        ? corporateDrilldown?.[fetchCorporateDrilldown]?.[corporateIndex]
        : corporateDrilldown?.[fetchCorporateDrilldown] ||
          (() => {
            const subModuleParts = selectedRowData?.subModule?.split("_") || [];
            for (let i = subModuleParts.length - 1; i >= 0; i--) {
              const key = subModuleParts[i] as keyof typeof drilldownData;
              if (key in drilldownData) {
                return drilldownData[key];
              }
            }
            return undefined;
          })()
      : drilldownData[selectedRowData?.subModule?.split("_").pop() as keyof typeof drilldownData];

  const drawerFields = predefinedFields || generateFieldsFromPayload(drilldown?.payload);
  return (
    <ContentWrapper title="Approval Management">
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
          setSearchString("");
          setCurrentPage(0);
        }}
      />
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className="!mb-0"
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={handleCloseDrawer}
        fields={drawerFields}
        actions={query?.get("activeTab") === "pending" ? actions : []}
        data={drilldown?.payload}
        isLoading={drilldownLoading}
        reviewNotes={
          query.get("activeTab") !== "approved" && query.get("activeTab") !== "rejected"
            ? drilldown?.reviewNotes
            : undefined
        }
        draftCount={drilldown?.draftCount || 0}
        moduleName={drilldown?.moduleKey?.split("_").pop() || ""}
      />
    </ContentWrapper>
  );
};
